export const NEW_INTEGRATION_MODAL_ID = 'new-integration-modal';
